import { trimSlashes } from './utils/url'

export const mediaUrl = (path) => `${process.env.NEXT_PUBLIC_BH_MEDIA_PREFIX || ''}/${trimSlashes(path)}`

export const assetUrl = (path) => `${process.env.NEXT_PUBLIC_BH_ASSET_PREFIX || ''}/${trimSlashes(path)}`

export const sameOriginMediaUrl = (path) => `${process.env.NEXT_PUBLIC_BH_PROXY_MEDIA_PATH || ''}/${trimSlashes(path)}`
